import React, { useState, useEffect } from "react";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import AllBookTemplate from './AllBookTemplate';
import Search from "./Search";
import Carousel from "./Carousel";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";

const Homepage = () => {
  const [latest, setLatest] = useState([]);
  const [top, setTop] = useState([]);
  const [products, setProducts] = useState([]);
  const [isAllBooks, setIsAllBooks] = useState(false);
  const [cartUpdated, setCartUpdated] = useState(false);
  const [auth, setAuth] = useState(false);
  const [home, setHome] = useState(true);
  const [key, setKey] = useState();
  
  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearchCallback = (searchKeyword) => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const data = JSON.stringify({
      search_text: searchKeyword
    });
    const config = {
      method: 'post',
      url: `${backendBookartUrl}/search?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: data
    };
    
    axios(config)
      .then(response => {
        const products = response.data.products || [];
        setProducts(products);
        setIsAllBooks(false);
        setKey(Date.now());
        setHome(false);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const checkAndUpdatedCart = (flag) => {
    setCartUpdated(flag);
  };

  const getData = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const dataTop = JSON.stringify({ "search_value": "top_seller" });
    const configTop = {
      method: 'post',
      url: `${backendBookartUrl}/allbooks?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: dataTop
    };

    axios(configTop)
      .then(response => {
        setTop(response.data.products);
      })
      .catch(error => {
        console.log(error);
      });

    const dataLatest = JSON.stringify({ "search_value": "latest_edition" });
    const configLatest = {
      method: 'post',
      url: `${backendBookartUrl}/allbooks?=`,
      headers: {
        "Authorization":`Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data: dataLatest
    };

    axios(configLatest)
      .then(response => {
        setLatest(response.data.products);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    } else {
      setAuth(true);
      return true;
    }
  };

  const gotohome = () => {
    window.location.reload();
};

  if (!auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader cartUpdated={cartUpdated} />

        <section className="container">
        <Search callbackFunction={handleSearchCallback} />
        </section>
        {home ? (
          <div className="container">
            <section>
              New/upcoming release
              <Carousel array={latest} checkAndUpdatedCart={checkAndUpdatedCart} />
            </section>
            <hr />
            <section>
              Top Seller
              <Carousel array={top} checkAndUpdatedCart={checkAndUpdatedCart} />
            </section>
          </div>
         ) : (
          <section className="container">
           <div className="search-results-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
           <h3>Search Books</h3>
             <button
            className="es-button small primary "
            type="button"
            onClick={gotohome}
            style={{ marginLeft: "auto" }}
          >
        <span>Go to Home</span> 
             <svg
              focusable="false"
              height="16"
              viewBox="0 0 54 128"
              width="11"
            >
              <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
            </svg> 
          </button>
        </div>
        
          <AllBookTemplate
            key={key} // Use key to force re-render
            data={products} // Pass the products to AllBookTemplate
            is_allBooks={isAllBooks}
            checkAndUpdatedCart={checkAndUpdatedCart} // Ensure this prop is passed correctly
          />
          </section>
        )}
        <Footer />
      </React.Fragment>
    );
  }
};

export default Homepage;